/**
 * Every URL the site serves, in one place (spec section 5).
 *
 * The site was built under `/next` with `noindex` and swapped to the root on
 * the founder's word, 4 Oct 2026 (sitetour-12). `/next/*` now redirects here
 * (public/_redirects, and `NEXT_REDIRECTS` in routes.tsx for the app shell).
 */
import type { Door } from './tour/types';

export const SITE_BASE: string = '';

/** Where the preview lived, so an old link still lands (sitetour-12). */
export const PREVIEW_BASE = '/next';

/** While the site is a preview it carries `noindex`. */
export const SITE_IS_PREVIEW = SITE_BASE !== '';

export const DOOR_SLUG: Readonly<Record<Door, string>> = {
    business: 'for-business',
    accountant: 'for-accountants',
    client: 'for-clients',
};

const lc = (cc: string) => cc.toLowerCase();

export const sitePaths = {
    root: () => SITE_BASE || '/',
    home: (cc: string) => `${SITE_BASE}/${lc(cc)}`,
    door: (cc: string, door: Door) => `${SITE_BASE}/${lc(cc)}/${DOOR_SLUG[door]}`,
    everything: (cc: string) => `${SITE_BASE}/${lc(cc)}/everything`,
    news: (cc: string) => `${SITE_BASE}/${lc(cc)}/new`,
    entry: (id: string) => `${SITE_BASE}/tour/${id}`,
};

/** Where the app's own doors are. */
export const APP_PATHS = {
    signIn: '/auth/signin',
    signUp: '/auth/signup',
    knowledge: '/knowledge/blog',
    partners: '/partners',
    legal: (doc: 'terms' | 'privacy' | 'refund') => `/legal/${doc}`,
};
